export default __webpack_public_path__ + "static/media/brands.15f2203f.svg";